import { render, staticRenderFns } from "./MyMenuCloudListItem.vue?vue&type=template&id=0bd47d04&"
import script from "./MyMenuCloudListItem.vue?vue&type=script&lang=js&"
export * from "./MyMenuCloudListItem.vue?vue&type=script&lang=js&"
import style0 from "./MyMenuCloudListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports